import { withTranslation } from 'react-i18next';
import LoadMoreComponent from '../../components/LoadMoreComponent';

import query from './query';
import Table from './Table';

class Summary extends LoadMoreComponent {
    constructor(props) {
        super();
        this.query = query({ offset: 0, domain: props.domain });

        this.offsetStep = 100;
    }

    getTestTopics(data, avg) {
        return data.filter((item) => item.impressions >= avg && item.pages < 5);
    }

    getTopics(data, avg) {
        return data.filter((item) => item.impressions >= avg && item.pages > 10);
    }

    render() {
        const { t } = this.props;
        const firstExtraBox = () => (
            <div className="table-header-subtitle mb-10">
                {t('opportunities.discover.entities.text1')}
            </div>
        );
        const secondExtraBox = () => (
            <div className="table-header-subtitle mb-10">
                {t('opportunities.discover.entities.text2')}
            </div>
        );
        return (
            <>
                <div className="row card-row d-flex" id="recommendations-topics">
                    <div className="col-12">
                        <div className="card table-main rounded-main overflow-hidden">
                            <Table
                                query={query}
                                data={this.state.data}
                                allData={this.state.allData}
                                domain={this.props.domain}
                                isLoadMore={this.state.loadMore}
                                loadMore={this.loadMore}
                                loading={this.state.loading}
                                content_id="recommendations-topics"
                                parent_id="recommendations-content"
                                direct_parent_id="recommended-topics-container"
                                getData={this.getTopics}
                                forceRun={this.forceRun}
                                header={t('opportunities.discover.entities.continue_header')}
                                extraBtns={firstExtraBox}
                            />
                        </div>
                    </div>
                </div>
                <div className="row card-row d-flex" id="recommendations-test-topics">
                    <div className="col-12">
                        <div className="card table-main rounded-main overflow-hidden">
                            <Table
                                query={query}
                                data={this.state.data}
                                allData={this.state.allData}
                                domain={this.props.domain}
                                isLoadMore={this.state.loadMore}
                                loadMore={this.loadMore}
                                loading={this.state.loading}
                                content_id="recommendations-test-topics"
                                parent_id="recommendations-content"
                                header={t('opportunities.discover.entities.header')}
                                direct_parent_id="recommended-topics-container"
                                getData={this.getTestTopics}
                                forceRun={this.forceRun}
                                extraBtns={secondExtraBox}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(Summary);
